export const PAGE_SELECTION_TYPE_NONE = "none";
export const PAGE_SELECTION_TYPE_STORY = "story";
export const PAGE_SELECTION_TYPE_HASHTAG = "hashtag";
export const PAGE_SELECTION_TYPE_SEASON = "season";
export const PAGE_SELECTION_TYPE_STORY_PARENT = "story-parent";

export const PAGE_SELECTION_TYPE_BY_PAGE_SLUG = {
  story: PAGE_SELECTION_TYPE_STORY,
  "stories-with-hashtag-page": PAGE_SELECTION_TYPE_HASHTAG,
  "show/season": PAGE_SELECTION_TYPE_SEASON,
  "story-parent": PAGE_SELECTION_TYPE_STORY_PARENT,
};

// Membership = "this page type needs a sourced entity"; absence = plain page nav.
export const PAGE_SELECTION_TYPE_REQUIRED_CONTEXT = {
  [PAGE_SELECTION_TYPE_STORY]: { contextName: "story", entityType: "Story" },
  [PAGE_SELECTION_TYPE_SEASON]: { contextName: "season", entityType: "Season" },
  show: { contextName: "show", entityType: "Show" },
  episode: { contextName: "episode", entityType: "Episode" },
  event: { contextName: "event", entityType: "Event" },
};

export const CLICK_GESTURE_CLICK = "click";
export const CLICK_GESTURE_DOUBLE_CLICK = "doubleClick";
export const CLICK_GESTURE_RIGHT_CLICK = "rightClick";
export const CLICK_GESTURE_SWIPE_LEFT = "swipeLeft";
export const CLICK_GESTURE_SWIPE_RIGHT = "swipeRight";
export const CLICK_GESTURE_SWIPE_UP = "swipeUp";
export const CLICK_GESTURE_SWIPE_DOWN = "swipeDown";
export const CLICK_GESTURE_PINCH = "pinch";
export const CLICK_GESTURE_SPREAD = "spread";
export const CLICK_GESTURE_ROTATE_LEFT = "rotateLeft";
export const CLICK_GESTURE_ROTATE_RIGHT = "rotateRight";

export const CLICK_GESTURE_OPTIONS = {
  [CLICK_GESTURE_CLICK]: { name: "Click / Tap", icon: "mdi:cursor-default-click" },
  [CLICK_GESTURE_DOUBLE_CLICK]: { name: "Double Click / Double Tap", icon: "mdi:cursor-default-click-outline" },
  [CLICK_GESTURE_RIGHT_CLICK]: { name: "Right Click / Long Press", icon: "mdi:mouse-right-click" },
  [CLICK_GESTURE_SWIPE_LEFT]: { name: "Swipe Left", icon: "mdi:gesture-swipe-left" },
  [CLICK_GESTURE_SWIPE_RIGHT]: { name: "Swipe Right", icon: "mdi:gesture-swipe-right" },
  [CLICK_GESTURE_SWIPE_UP]: { name: "Swipe Up", icon: "mdi:gesture-swipe-up" },
  [CLICK_GESTURE_SWIPE_DOWN]: { name: "Swipe Down", icon: "mdi:gesture-swipe-down" },
  [CLICK_GESTURE_PINCH]: { name: "Pinch", icon: "mdi:gesture-pinch" },
  [CLICK_GESTURE_SPREAD]: { name: "Spread", icon: "mdi:gesture-spread" },
  [CLICK_GESTURE_ROTATE_LEFT]: { name: "Rotate Left", icon: "mdi:rotate-left" },
  [CLICK_GESTURE_ROTATE_RIGHT]: { name: "Rotate Right", icon: "mdi:rotate-right" },
};

export const CLICK_GESTURE_ORDER = Object.keys(CLICK_GESTURE_OPTIONS);

export const CLICK_FINGER_OPTIONS = [
  { id: 1, name: "One finger" },
  { id: 2, name: "Two fingers" },
  { id: 3, name: "Three fingers" },
];
